<template>
  <div>
    <jd-form
      class="mb16"
      :formData="searchInfo"
      :form-info="getXhsFormInfo"
      @search="getXhsParticipateRecord"
      ref="funGameRecordRef"
    ></jd-form>
    <div style="margin-bottom: 16px" class="flex-between">
     <div>
      <jd-button
        type="blueLine"
        :disabled="!selectedRows.length"
        @click="batchAudit"
        >批量审核</jd-button
      >
      <jd-button :disabled="!dataSource.length" @click="addCrowd"
        >按查询结果生成人群</jd-button
      >
     </div>
      <jd-button type="text" :disabled="!dataSource.length" @click="exportAll">导出</jd-button>
    </div>
    <div class="new-table-box">
      <jd-table
        :loading="loading"
        :tableData="dataSource"
        :tableInfo="tableInfo"
        :header-cell-style="{ background: '#fafafa', 'text-align': 'left' }"
        :cell-style="{ 'text-align': 'left' }"
        style="width: 100%"
        row-key="id"
        :pageInfo="{
          pageNum: formList.current,
          pageSize: formList.size,
          total: total,
        }"
        :selection="selection"
        :selectable="selectable"
        @handleSelectionChange="handleSelectionChange"
        @handlePage="handleCurrentChangeAll"
      >
        <template #sellerLinkNameSlot="{ row }">
          <div>{{ row.sellerLinkName || "-" }}</div>
        </template>
        <template #shareUrlSlot="{ row }">
          <img :src="row.shareUrl" width="50" height="50" alt="" />
        </template>
        <template #shareContextSlot="{ row }">
         <div>{{ row.shareContext || "-" }}</div>
        </template>
        <template #processStatusSlot="{ row }">
          <div>{{ row.processStatus }}</div>
        </template>
        <template #processTimeSlot="{ row }">
          <div>{{ row.processTime || "-" }}</div>
        </template>
        <template #processRemarkSlot="{ row }">
          <div>{{ row.processRemark || "-" }}</div>
        </template>
        <template #operationSlot="{ row }">
          <jd-button
            type="blueText"
            :disabled="row.processStatus != '待审核'"
            @click="handleAudit(row)"
            >审核</jd-button
          >
        </template>
      </jd-table>
    </div>
    <!-- 生成人群 -->
    <crowdDialog
      v-if="isShowCrowdDialog"
      :isShowCrowdDialog.sync="isShowCrowdDialog"
      :activityType="rowData.activityType"
      :source="6"
      :defaultValue="hasDefaultValue"
      :defaultValueText="defaultValueText"
      :searchForm="crowCondition"
      @close="crowdClose"
    />

    <!-- 导出 -->
    <generate
      :control="openRemarkDialog"
      v-if="openRemarkDialog"
      @transData="(val) => (openRemarkDialog = val)"
      @transData1="confirmExport"
    ></generate>
    <auditInfo
      v-model="isShowDialog"
      :isBatch="isBatch"
      :rowData="auditRowData"
      :activityId="rowData.id"
      :proccessSelection="selectedRows"
      @update="getList()"
    />
  </div>
</template>

<script>
import crowdDialog from "../../crowd-Dialog.vue";
import {
  getXhsJoinRecord,
  getXhsJoinRecordExport,
} from "@/api/jhk/paradiseAndTaskCommonController.js";
import auditInfo from "./auditInfo.vue";
export default {
  components: {
    crowdDialog,
    auditInfo,
  },
  props: {
    inputXhsInfo: {
      type: Array,
      default: () => [],
    },
    rowData: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      selection: true,
      total: 0,
      formList: {
        size: 10,
        current: 1,
      },
      dataSource: [],
      loading: false,
      searchInfo: {
        memberNick: "",
        pin: "",
        sellerLinkId: "",
        startTime: "",
        endTime: "",
        processStatus: "",
      }, // 搜索参数
      isShowCrowdDialog: false, // 生成人群
      hasDefaultValue: true, // 是否有默认值
      defaultValueText: "参与记录", // 默认值文本
      openRemarkDialog: false, // 导出备注弹窗
      crowCondition: {},
      selectedRows: [],
      isShowDialog: false,
      isBatch: false, // // 批量操作
      auditRowData: {},
      tableInfo: [
        {
          prop: "memberNick",
          label: "用户昵称",
          width: "120",
        },
        {
          prop: "chaosPin",
          label: "用户pin（加密）",
          width: "120",
        },
        {
          prop: "sellerLinkName",
          slot: "sellerLinkNameSlot",
          label: "投放渠道",
          width: "120",
        },
        {
          prop: "createTime",
          label: "参与时间",
          width: "160",
        },
        {
          prop: "orderId",
          label: "参与活动订单",
          width: "150",
        },
        {
          prop: "orderAmt",
          label: "订单金额",
          width: "120",
        },
        {
          prop: "shareUrl",
          slot: "shareUrlSlot",
          label: "晒单图片",
          width: "120",
        },
        {
          prop: "shareContext",
          type: "scalable",
          slot: "shareContextSlot",
          label: "晒单正文",
          width: "150",
        },
        {
          prop: "linkContent",
          label: "提交链接",
          width: "150",
        },
        {
          prop: "processStatus",
          slot: "processStatusSlot",
          label: "审核状态",
          width: "120",
        },
        {
          prop: "processTime",
          slot: "processTimeSlot",
          label: "审核时间",
          width: "150",
        },
        {
          prop: "processRemark",
          type: "scalable",
          slot: "processRemarkSlot",
          label: "审核备注",
          width: "150",
        },
        {
          prop: "isReceive",
          label: "是否领取奖品",
          width: "120",
        },
        {
          prop: "operation",
          slot: "operationSlot",
          label: "操作",
          width: "120",
          fixed: "right",
        },
      ],
    };
  },
  computed: {
    getXhsFormInfo: {
      get() {
        return this.inputXhsInfo;
      },
      set(val) {
        this.$emit("update:inputXhsInfo", val);
      },
    },
  },
  mounted() {
    this.getList();
  },
  methods: {
    getSatus(status) {
      const statusMap = {
        "-1": "待提交",
        0: "待审核",
        1: "已通过",
        2: "已驳回",
      };
      return statusMap[status] || "-";
    },
    batchAudit() {
      this.isShowDialog = true;
      this.isBatch = true;
    },
    handleSelectionChange(val) {
      this.selectedRows = val;
    },
    selectable(row, index) {
      if (row.processStatus == "待审核") {
        return true;
      } else {
        return false;
      }
    },
    handleAudit(row) {
      this.isShowDialog = true;
      this.isBatch = false;
      this.auditRowData = row;
    },
    handleCurrentChangeAll(val) {
      this.formList.size = val.pageSize;
      this.formList.current = val.pageNum;
      this.getList();
    },
    /**
     * 搜索
     * @param params 查询参数
     * @param type 类型 reset 重置  search 搜索
     */
    getXhsParticipateRecord(params) {
      this.formList.current = 1;
      this.formList.size = 10;
      this.searchInfo.nickName = params.nickName ? params.nickName : "";
      this.searchInfo.pin = params.pin ? params.pin : "";
      this.searchInfo.sellerLinkId = params.sellerLinkId
        ? params.sellerLinkId
        : "";
      this.searchInfo.startTime = params.startTime ? params.startTime : "";
      this.searchInfo.endTime = params.endTime ? params.endTime : "";
      this.searchInfo.processStatus = params.processStatus;
      this.getList();
    },
    async getList() {
      try {
        this.loading = true;
        const params = {
          ...this.searchInfo,
          ...this.formList,
          activityId: this.rowData.id,
        };
        this.crowCondition = {
          ...params,
          hdSource: 6,
          activityType: this.rowData.activityType,
        };
        const res = await getXhsJoinRecord(params);
        let { records = [], total = 0 } = res.data;
        this.dataSource = records;
        this.total = Number(total);
      } catch (error) {
      } finally {
        this.loading = false;
      }
    },
    /**
     * 生成人群
     */
    addCrowd() {
      this.hasDefaultValue = true;
      this.defaultValueText = "参与记录-";
      this.isShowCrowdDialog = true;
    },
    crowdClose() {
      this.isShowCrowdDialog = false;
      // 关闭时重置
      if (this.hasDefaultValue) {
        this.hasDefaultValue = false;
        this.defaultValueText = "";
      }
    },
    /**
     * 导出
     */
    exportAll() {
      this.openRemarkDialog = true;
    },
    /**
     * 确认导出
     * @param exportRemark 备注内容
     */
    confirmExport(remark = "") {
      let params = {
        ...this.formList,
        ...this.searchInfo,
        activityId: this.rowData.id,
        remark,
      };
      this.formLoading = true;
      getXhsJoinRecordExport(params).then((res) => {
        this.formLoading = false;
        if (res.code == 1) {
          this.$message.success(res.message);
        } else {
          this.$message.error(res.message);
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.flex-between {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
</style>
